import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { computed } from '@angular/core';
import { UserInterface } from '../../app/shared/interfaces/global';

export function withUserComputed() {
  return signalStoreFeature(
    { state: type<UserInterface>() },
    withComputed((state) => ({
      getUser: computed(() => state),
      getUserName: computed(
        () => () => `${state.name()} ${state.last_name()}`.trim(),
      ),
    })),
  );
}
